function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { active_category_type } from "./options_modal";
import QuantityEditor from "./quantity_editor";
import IconButton from "./icon_button";
import { Fragment } from "react";
import SelectedOption from "./selected_option";
var SelectedOptionsWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 5px;\n  padding: 0px 5px;\n  background-color: #F7F7F7;\n  border: 1px solid  #CCCCCC;\n  border-radius: 4px;\n"])));
var SelectedOptionsHeader = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 4px 4px 4px 0px;\n  cursor: pointer;\n  justify-content: space-between;\n  align-items: center;\n\n  @media (max-width: ", "px) {\n    padding: 4px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var SelectedOptionsTitle = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  font-weight: 400;\n  font-size: 14px;\n  color: #626469;\n  @media (max-width: ", "px) {\n    display: none;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var MobileSelectedOptionsTitle = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: none;\n  color: #626469;\n  font-size: 14px;\n  @media (max-width: ", "px) {\n    display: block;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var SelectedOptionsArrowWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  padding: 4px;\n  box-sizing: border-box;\n  transform: ", ";\n  transition: transform 250ms;\n  display: flex;\n  align-items: center;\n"])), function (props) {
  return props.isOpen ? "rotate(0deg)" : "rotate(-90deg)";
});
var SelectedOptionsContent = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 4px 4px 10px 0px;\n  @media (max-width: ", "px) {\n    padding: 4px;\n  }\n"])), function (props) {
  return props.mobileBreakpoint ? props.mobileBreakpoint : 800;
});
var SelectedOptionsCategory = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 5px;\n"])));
var SelectedOptionsTitleWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n"])));
var SelectedOptionsCategoryTitle = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 12px;\n  color: #626469;\n"])));
var AddMore = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  margin-left: 10px;\n  color: ", ";\n\n  cursor: pointer;\n  :hover {\n    text-decoration: underline;\n  }\n"])), function (props) {
  return props.color ? props.color : '#42B4E6';
});
var EditAndDeleteWrapper = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var SelectedOptions = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectedOptions, _React$Component);
  var _super = _createSuper(SelectedOptions);
  function SelectedOptions(props) {
    var _this;
    _classCallCheck(this, SelectedOptions);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "removeItem", function (item) {
      if (item.onRemove) {
        item.onRemove(_this.props.moduleItem.deviceIdentification, item.optionIdentification);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderQuantity", function (item) {
      return /*#__PURE__*/React.createElement(QuantityEditor, {
        primaryColor: _this.props.primaryColor,
        primaryTextColor: _this.props.primaryTextColor,
        isSaving: _this.props.isSaving,
        quantity: item.quantity,
        canIncrease: item.canIncrease,
        onIncrease: function onIncrease() {
          item.onIncrease(_this.props.moduleItem.deviceIdentification, item.optionIdentification, 1);
        },
        canDecrease: item.canDecrease,
        onDecrease: function onDecrease() {
          if (item.quantity === 1) {
            _this.removeItem(item);
          } else {
            item.onDecrease(_this.props.moduleItem.deviceIdentification, item.optionIdentification, 1);
          }
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderActionButtons", function (item, categoryModalKey) {
      return /*#__PURE__*/React.createElement(EditAndDeleteWrapper, null, item.canShowInModal && /*#__PURE__*/React.createElement(IconButton, {
        icon: "edit",
        size: 40,
        padding: 7,
        color: _this.props.primaryColor,
        onClick: function onClick() {
          _this.props.onViewAccessory(item, categoryModalKey, item.filterStatusOnEdit, item.disablePreviousOnEdit || false);
        },
        disabled: _this.props.isSaving
      }), item.canRemove && /*#__PURE__*/React.createElement(IconButton, {
        icon: "remove",
        size: 40,
        padding: 7,
        color: '#626469',
        onClick: function onClick() {
          _this.removeItem(item);
        },
        disabled: _this.props.isSaving
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "renderSelectedOptionsCategory", function (category, categoryTitle, nbOptions, categoryModalKey) {
      return /*#__PURE__*/React.createElement(SelectedOptionsCategory, null, /*#__PURE__*/React.createElement(SelectedOptionsTitleWrapper, null, /*#__PURE__*/React.createElement(SelectedOptionsCategoryTitle, null, "".concat(categoryTitle, " (").concat(nbOptions, ")")), /*#__PURE__*/React.createElement(AddMore, {
        id: "".concat(_this.props.moduleItem.deviceIdentification.identificationKey, "-add-more"),
        color: _this.props.primaryColor,
        onClick: function onClick() {
          _this.props.onAddMore(categoryModalKey);
        }
      }, _this.props.getLabel('options_screen.add_more'))), category.map(function (item, idx) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: idx
        }, /*#__PURE__*/React.createElement(SelectedOption, {
          renderProductLink: _this.props.renderProductLink,
          selectedOption: item,
          moduleItem: _this.props.moduleItem,
          isSaving: _this.props.isSaving,
          getLabel: _this.props.getLabel,
          primaryColor: _this.props.primaryColor,
          primaryTextColor: _this.props.primaryTextColor,
          onViewAccessory: _this.props.onViewAccessory,
          categoryModalKey: categoryModalKey
        }));
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "computeCategoryQuantity", function (optionsArray) {
      var result = 0;
      var _iterator = _createForOfIteratorHelper(optionsArray),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var opt = _step.value;
          result += opt.quantity;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "computeCategoryQuantityForSubAccessories", function (accessories) {
      var result = 0;
      var _iterator2 = _createForOfIteratorHelper(accessories),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var accessory = _step2.value;
          if (accessory.subAccessories) {
            var _iterator3 = _createForOfIteratorHelper(accessory.subAccessories),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var subAccessory = _step3.value;
                result += subAccessory.quantity;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "renderSelectedOptionLabel", function (nbSelectedOptions) {
      if (_this.props.optionsLoading) {
        return "".concat(_this.props.getLabel('options_screen.selected_options_for_device'), " (...)");
      }
      return "".concat(_this.props.getLabel('options_screen.selected_options_for_device'), " (").concat(nbSelectedOptions, ")");
    });
    _defineProperty(_assertThisInitialized(_this), "renderSelectedOptions", function (module) {
      var _module$selectedOptio, _module$selectedOptio2, _module$selectedOptio3, _module$selectedOptio4, _module$selectedOptio5;
      var nbAccessories = _this.computeCategoryQuantity(((_module$selectedOptio = module.selectedOptions) === null || _module$selectedOptio === void 0 ? void 0 : _module$selectedOptio.accessories) || []);
      var nbServices = _this.computeCategoryQuantity(((_module$selectedOptio2 = module.selectedOptions) === null || _module$selectedOptio2 === void 0 ? void 0 : _module$selectedOptio2.services) || []);
      var nbSubAccessories = _this.computeCategoryQuantityForSubAccessories(((_module$selectedOptio3 = module.selectedOptions) === null || _module$selectedOptio3 === void 0 ? void 0 : _module$selectedOptio3.accessories) || []);
      var nbSelectedOptions = nbAccessories + nbServices + nbSubAccessories;
      return /*#__PURE__*/React.createElement(React.Fragment, null, nbSelectedOptions > 0 && /*#__PURE__*/React.createElement(SelectedOptionsWrapper, null, /*#__PURE__*/React.createElement(SelectedOptionsHeader, {
        id: "".concat(module.deviceIdentification.identificationKey, "-selectedoptions-header"),
        mobileBreakpoint: _this.props.mobileBreakpoint,
        onClick: function onClick(event) {
          event.stopPropagation();
          _this.setState({
            showOptions: !_this.state.showOptions
          });
        }
      }, /*#__PURE__*/React.createElement(SelectedOptionsTitle, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, _this.renderSelectedOptionLabel(nbSelectedOptions)), /*#__PURE__*/React.createElement(MobileSelectedOptionsTitle, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, _this.renderSelectedOptionLabel(nbSelectedOptions)), /*#__PURE__*/React.createElement(SelectedOptionsArrowWrapper, {
        mobileBreakpoint: _this.props.mobileBreakpoint,
        isOpen: _this.state.showOptions
      }, " ", /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 1024 1024"
      }, /*#__PURE__*/React.createElement("path", {
        fill: "currentColor",
        d: "M134 347.2C126 339.2 126 325.2 134 317.2C138 313.2 144 311.2 149 311.2C155 311.2 160 313.2 164 317.2L510.6 663.5L860 315.5C864 311.5 869 309.5 875 309.5C880 309.5 886 311.5 890 315.5C898 323.5 898 337.5 890 345.5L526.6 708.5C517.6 716.5 504.6 716.5 495.6 708.5L134 347.2Z"
      })))), _this.state.showOptions && /*#__PURE__*/React.createElement(SelectedOptionsContent, {
        mobileBreakpoint: _this.props.mobileBreakpoint
      }, nbAccessories > 0 && _this.renderSelectedOptionsCategory((_module$selectedOptio4 = module.selectedOptions) === null || _module$selectedOptio4 === void 0 ? void 0 : _module$selectedOptio4.accessories, _this.props.getLabel('options_screen.accessories'), nbAccessories + nbSubAccessories, active_category_type.accessories), nbServices > 0 && _this.renderSelectedOptionsCategory((_module$selectedOptio5 = module.selectedOptions) === null || _module$selectedOptio5 === void 0 ? void 0 : _module$selectedOptio5.services, _this.props.getLabel('options_screen.services'), nbServices, active_category_type.services))));
    });
    _this.state = {
      showOptions: false
    };
    return _this;
  }
  _createClass(SelectedOptions, [{
    key: "render",
    value: function render() {
      return this.renderSelectedOptions(this.props.moduleItem);
    }
  }]);
  return SelectedOptions;
}(React.Component);
_defineProperty(SelectedOptions, "propTypes", {
  renderProductLink: PropTypes.func,
  moduleItem: PropTypes.object,
  isSaving: PropTypes.bool,
  getLabel: PropTypes.func,
  primaryColor: PropTypes.string,
  primaryTextColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  secondaryTextColor: PropTypes.string,
  onAddMore: PropTypes.func,
  onViewAccessory: PropTypes.func,
  optionsLoading: PropTypes.bool
});
export default SelectedOptions;